import React from 'react';
import { connect } from 'react-redux';
import { CreditCard, CheckCircle } from 'lucide-react';
import { getOpenedTaskPaymentTransaction } from '../../../../../redux/tasks/taskEntities/selectors';

const TaskDetailsPayment = ({ paymentTransaction }) => {
  if (!paymentTransaction) return null;

  const total = (paymentTransaction.amount / 100).toFixed(2);
  const currency = paymentTransaction.currency?.toUpperCase() || '';
  const products = paymentTransaction.products || [];

  return (
    <>
      <div className="w-full mt-4 mb-2">
        <div className="text-[11px] font-semibold uppercase tracking-wider" style={{ color: 'rgba(15,15,25,0.35)' }}>
          Payment
        </div>
      </div>

      <div className="rounded-xl overflow-hidden" style={{ border: '1px solid rgba(99,102,241,0.12)' }}>
        {/* Status row */}
        <div
          className="flex items-stretch"
          style={{ borderBottom: products.length > 0 ? '1px solid rgba(99,102,241,0.08)' : 'none', minHeight: 40 }}
        >
          <div
            className="flex items-center gap-2 flex-shrink-0"
            style={{ width: '42%', borderRight: '1px solid rgba(99,102,241,0.08)', padding: '8px 10px' }}
          >
            <div className="size-6 flex-shrink-0 rounded-md flex justify-center items-center" style={{ backgroundColor: '#6366f1' }}>
              <CreditCard size={13} color="white" />
            </div>
            <span className="truncate text-[12.5px] font-medium" style={{ color: 'rgba(15,15,25,0.65)' }}>
              Status
            </span>
          </div>
          <div className="flex items-center gap-1.5 px-3 py-2" style={{ flex: 1 }}>
            <CheckCircle size={13} color="#22c55e" />
            <span className="text-[12.5px] font-semibold" style={{ color: '#16a34a' }}>
              Paid — ${total} {currency}
            </span>
          </div>
        </div>

        {/* Product rows */}
        {products.map((p, i) => {
          const lineTotal = ((p.price * p.quantity) / 100).toFixed(2);
          const isLast = i === products.length - 1;
          return (
            <div
              key={i}
              className="flex items-stretch"
              style={{ borderBottom: isLast ? 'none' : '1px solid rgba(99,102,241,0.08)', minHeight: 40 }}
            >
              <div
                className="flex items-center gap-2 flex-shrink-0"
                style={{ width: '42%', borderRight: '1px solid rgba(99,102,241,0.08)', padding: '8px 10px' }}
              >
                <div className="size-6 flex-shrink-0 rounded-md flex justify-center items-center" style={{ backgroundColor: '#8b5cf6' }}>
                  <span style={{ color: 'white', fontSize: 9, fontWeight: 700 }}>×{p.quantity}</span>
                </div>
                <span className="truncate text-[12.5px] font-medium" style={{ color: 'rgba(15,15,25,0.65)' }}>
                  {p.name}
                </span>
              </div>
              <div className="flex items-center px-3 py-2" style={{ flex: 1 }}>
                <span className="text-[12.5px]" style={{ color: 'rgba(15,15,25,0.7)' }}>
                  ${lineTotal} {(p.currency || currency).toUpperCase()}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  paymentTransaction: getOpenedTaskPaymentTransaction(state),
});

export default connect(mapStateToProps)(TaskDetailsPayment);
